<template>
  <div id="tablaproductosventas" class="table-wrapper">
    <b-table :data="listaProductos.slice().reverse()">
      <b-table-column field="codigo" label="Código" v-slot="props">
        {{ props.row.codigo }}
      </b-table-column>

      <b-table-column field="nombre" label="Nombre" v-slot="props">
        {{ props.row.nombre }}
      </b-table-column>

      <b-table-column field="precio" label="Precio" v-slot="props">
        <span @click="cambiarPrecio(props.row)" style="cursor: pointer">
          ${{ parseInt(props.row.precio).toLocaleString("es-CO") }}
        </span>
      </b-table-column>

      <b-table-column field="cantidad" label="Cantidad" v-slot="props">
  <b-field>
    <CustomNumberInput
      v-model="props.row.cantidad"
      @cambio="aumentar(props.row)"
    />
  </b-field>
</b-table-column>


      <b-table-column field="subtotal" label="Subtotal" v-slot="props">
        <b>${{ (props.row.precio * parseFloat(props.row.cantidad)).toLocaleString("es-CO", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }) }}</b>
      </b-table-column>

      <b-table-column v-if="datosNegocio.preciosVarios === 1" field="OTP2" label="OTP2" v-slot="props">
        <b-button type="is-info" @click="otp2(props.row)">2</b-button>
      </b-table-column>

      <b-table-column v-if="datosNegocio.preciosVarios === 1" field="OTP3" label="OTP3" v-slot="props">
        <b-button type="is-info" @click="otp3(props.row)">3</b-button>
      </b-table-column>

      <b-table-column field="quitar" label="Quitar" v-slot="props">
        <b-button icon-left="delete" type="is-danger" @click="quitar(props.row.id)">Quitar</b-button>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
import CustomNumberInput from "./CustomNumberInput.vue";

export default {
  name: "TablaProductos",
  props: ["listaProductos"],
  components: {
    CustomNumberInput,
  },
  data: () => ({
    precio2: "",
    precio3: "",
    datosNegocio: {},
  }),
  methods: {
    aumentar(producto) {
      this.$emit("aumentar", producto);
    },

    quitar(id) {
      this.$emit("quitar", id);
    },
    otp2(producto) {
      this.$emit("otp2", producto);
    },
    otp3(producto) {
      this.$emit("otp3", producto);
    },
    cambiarPrecio(producto) {
      this.$emit("cambiarPrecio", producto);
    },
    obtenerDatosNegocio() {
      HttpService.obtenerConConsultas("ajustes.php", {
        accion: "obtener",
      }).then((resultado) => {
        this.datosNegocio = resultado;
      });
    },
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
    this.obtenerDatosNegocio();
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
};
</script>

<style>
#tablaproductosventas {
  max-height: 53vh;
  overflow-y: auto;
}
</style>
